(ns common.ui.side-menu
  (:require ["@mui/material/Drawer$default" :as Drawer]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tooltip$default" :as Tooltip]
            [common.ui.validation.view :as validation]
            [manage.adset.hooks :as ah]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(rf/reg-sub :side-menu/current
  :<- [:router/current-route]
  (fn [current-route _]
    (get-in current-route [:parameters :query :menu])))

(rf/reg-event-fx :side-menu/open
  (fn [_ [_ menu]]
    {:fx [[:dispatch [:entity/view {:menu menu}]]]}))

(rf/reg-sub :side-menu/link
  :<- [:router/handler-name]
  :<- [:router/path-params]
  :<- [:router/fragment]
  (fn [[handler-name path-params fragment] [_ menu]]
    (r.easy/href handler-name path-params {:menu menu} (some-> fragment name))))

(rf/reg-event-fx :side-menu/default
  ;; loads given menu, but only if no existing view is set in query-params
  [(rf/inject-cofx :sub [:entity/current-query-params])]
  (fn [{entity-query-params :entity/current-query-params} [_ menu]]
    (when-not entity-query-params
      {:fx [[:dispatch [:side-menu/open menu]]]})))

(defui side-menu-item [{:keys [menu ev active?]}]
  (let [{:keys [targetType]} (ah/use-adset)
        link (use-subscribe [:side-menu/link menu])]
    ($ Tooltip
       {:placement :left
        :title (r/as-element (:entity/label ev))}
       ($ Stack {:component "li"
                 :position "relative"}
          ($ validation/view-results {:stack-props {:data-component :side-menu-validation
                                                    :position "absolute"
                                                    :right "12px"
                                                    :top "6px"}
                                      :render-type :dot
                                      :validation-results-sub [:entity/publish-blocking-errors-and-warnings ev]})
          ($ IconButton (cond-> {:href link
                                 :disabled (and (= menu :trafficking) (= targetType "youtube"))
                                 :data-testid (str "side-menu-item-" (:entity/label ev))
                                 :sx #js {:margin "auto"}}
                          active? (assoc :color :primary))
             (when-some [icon (:entity/icon ev)]
               (if (string? icon)
                 ($ Icon icon)
                 (r/as-element icon))))))))

(def side-menu-width "6rem")

(defui side-menu [{:keys [menu-entries-cfg]}]
  (let [active-menu (use-subscribe [:side-menu/current])]
    ($ Drawer {:open true
               :variant "permanent"
               :anchor "right"
               :data-testid "right-menu"
               :sx #js {:py 3
                        :position "relative"
                        :width side-menu-width
                        ".MuiDrawer-paper" #js {:position "absolute"
                                                :inset 0}
                        ".MuiPaper-root" #js {:borderRadius 0}}}
       ($ Stack {:component "ul"
                 :spacing 1
                 :p 0}
          (for [[menu cfg] menu-entries-cfg]
            ($ side-menu-item {:key menu
                               :menu menu
                               :ev cfg
                               :active? (= menu active-menu)}))))))
